<div class="bg-main text-white px-4 py-2 flex justify-between items-center">
  <div>
    <img
      src="cmilogo.png"
      [alt]="'common.logoAlt' | translate"
      class="-ml-1 h-12 w-12 cursor-pointer"
      routerLink="/" />
  </div>

  @if (!hideTenantBar()) {
    <div class="flex items-center gap-4 relative flex-1 max-w-md mx-4">
      <div class="flex-1" #dropdownContainer>
        <button
          (click)="toggleDropdown()"
          class="flex items-center gap-2 hover:bg-white/10 p-2 rounded transition-colors w-full text-left"
          type="button"
          [title]="'tenantBar.selectTenantTitle' | translate">
          <span class="flex-1 truncate">
            @if (selectedTenant(); as tenant) {
              {{ tenant.name }}
            } @else {
              {{ 'tenantBar.noTenantSelected' | translate }}
            }
          </span>
          <svg
            class="w-4 h-4 transition-transform shrink-0"
            [class.rotate-180]="isDropdownOpen()"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        @if (isDropdownOpen()) {
          <div
            class="absolute left-0 right-0 mt-2 bg-white text-gray-800 rounded shadow-lg z-50 max-h-64 overflow-y-auto">
            @if (tenants().length > 0) {
              @for (tenant of tenants(); track tenant.name) {
                <button
                  (click)="selectTenant(tenant.name)"
                  class="w-full text-left px-4 py-2 hover:bg-gray-100 transition-colors flex items-center justify-between"
                  type="button"
                  [class.bg-gray-50]="selectedTenant()?.name === tenant.name">
                  <span>{{ tenant.name }}</span>
                  @if (selectedTenant()?.name === tenant.name) {
                    <svg
                      class="w-5 h-5 text-green-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7" />
                    </svg>
                  }
                </button>
              }
            } @else {
              <div class="px-4 py-3 text-gray-500 text-sm">
                {{ 'tenantBar.noTenantsAvailable' | translate }}
              </div>
            }

            <a
              routerLink="/tenants"
              (click)="closeDropdown()"
              class="block border-t border-gray-200 px-4 py-2 text-sm text-main hover:bg-gray-100 transition-colors cursor-pointer">
              {{ 'tenantBar.manageTenants' | translate }}
            </a>
          </div>
        }
      </div>
    </div>
  }

  <div class="flex items-center gap-2">
    <!-- Host specific actions, e.g. the word add-in's settings cog. -->
    <ng-content select="[headerActions]" />

    <button
      (click)="logout()"
      class="p-1 hover:bg-white/10 rounded transition-colors"
      type="button"
      [attr.aria-label]="'logout.title' | translate"
      [title]="'logout.title' | translate">
      <img
        src="logout.svg"
        [alt]="'logout.title' | translate"
        class="size-5 cursor-pointer fill-current" />
    </button>
  </div>
</div>
